const $input = $('.search .search_input');
const $resultsWrapper = $('.search_results__wrapper');
const $spinner = $('.search_inner').find('.spinner');

const CancelToken = axios.CancelToken;
let cancel = null;

let searchRequestAJAX = null;
let lastSearchedString = '';
let lastSearchedIn = '';

function fetchAndShowSearchResults(searchedString, searchIn, searchAction) {
    const minLength = 3;

    const $targetedResultWrapper = $(`#search-${searchIn} .search_results__wrapper`);

    if (searchedString.length < minLength) {
        $targetedResultWrapper.empty();
        return;
    }

    if (searchedString == lastSearchedString && searchIn == lastSearchedIn) {
        return;
    }

    if ($targetedResultWrapper.is(':visible')) {
        $targetedResultWrapper.fadeOut('fast', () => {
            $spinner.fadeIn('fast');
        });
    }

    if (cancel !== null) {
        cancel();
    }

    if ($targetedResultWrapper.is(':visible')) {
        $targetedResultWrapper.fadeOut('fast');
    }

    lastSearchedString = searchedString;
    lastSearchedIn = searchIn;

    axios.get(searchAction, {
            params: {
                query: searchedString,
                searchIn: searchIn
            },
            cancelToken: new CancelToken(function executor(c) {
                // An executor function receives a cancel function as a parameter
                cancel = c;
            })
        })
        .then(function (response) {

            $(`#search-${response.data.searchIn} .search_results__wrapper`).html(response.data.html);
            if (!$targetedResultWrapper.is(':visible')) {
                $spinner.fadeOut('fast', () => {
                    $targetedResultWrapper.fadeIn('fast');
                });
            }

            var eventCategory = 'Global search';

            if (response.data.searchIn == 'products') {
                eventCategory = 'Products search';
            }

            trackEvent(eventCategory, 'submit', window.location.pathname);
        })
        .catch(function (error) {

        })
        .then(() => {
            cancel = null
        });
}

export default function () {
    let inputChangeTimer = null;

    $input.on('change input', event => {
        let $this = $(event.currentTarget);

        clearTimeout(inputChangeTimer);

        inputChangeTimer = setTimeout(() => {
            const searchedString = $this.val();
            const searchIn = $this.attr('data-search');
            const searchAction = $this.closest('form').attr('action');

            fetchAndShowSearchResults(searchedString, searchIn, searchAction);
        }, 500);
    });

    $input.closest('form').on('submit', event => {
        event.preventDefault();


        const searchedString = $this.val();
        const searchIn = $this.attr('data-search');
        const searchAction = $this.closest('form').attr('action');

        fetchAndShowSearchResults(searchedString, searchIn, searchAction);
    });

    $input.closest('form').on('reset', event => {
        let $this = $(event.currentTarget);
        const searchIn = $this.attr('data-search');
        const searchValue = $this.find('.search_input').val();

        const $targetedResultWrapper = $(`#search-${searchIn} .search_results__wrapper`);

        if(searchValue === '') {
            $('.to-blur').removeClass('to-blur--blured');
            $('.search--fixed').fadeOut(500);
            $('.search--fixed').find('form')[0].reset();
            $('body').removeClass('overflow-hidden');
            $('.nav-menu_item--search').removeClass('nav-menu_item--active');
            $('.header-nav_search').removeClass('header-nav_search--active');
        }

        $targetedResultWrapper.fadeOut(() => {
            fetchAndShowSearchResults('', searchIn, '');
        });
    });

    $resultsWrapper.on('click', '.search_results__link_show-all', event => {
        event.preventDefault();
        let $this = $(event.currentTarget);

        $('.search_results .search_results__list li.hidable-item').show();

        $this.hide();
        $('.search_results__wrapper .search_results__link_hide').show();
    });

    $resultsWrapper.on('click', '.search_results__link_hide', event => {
        event.preventDefault();
        let $this = $(event.currentTarget);

        $('.search_results .search_results__list li.hidable-item').hide();

        $this.hide();
        $('.search_results__wrapper .search_results__link_show-all').show();
    });
}
